import { scrollToElement } from './utilities.js'

function header() {
	const mainHeader = document.querySelector('header#main_header')
	const nav = mainHeader.querySelector('nav[data-main-nav]')
	const subnavs = nav.querySelectorAll('.subnav')
	const subnavsLinks = nav.querySelectorAll('[data-second-level-subnav]')
	const menuOverlay = document.getElementById('menu_overlay')
	const mobileMenuToggle = document.getElementById('mobile_menu_toggle')
	const searchToggle = document.querySelector('header .search button[data-toggle]')
	const searchInput = document.querySelector('header .search input')

	const mainLinks = nav.querySelectorAll('ul > li > span')

	let expanded = false
	let menuExpanded = false
	let stuck = false
	let headerCollapsed = false
	let lastScrollY = window.scrollY
	let scrollDirection = 'down'

	// We have a local version of this value because we need to do some cleanup when transitioning between desktop and mobile.
	let navMobile = window.navMobile

	window.addEventListener('scroll', () => {
		const currentScrollY = window.scrollY
		scrollDirection = currentScrollY > lastScrollY ? 'down' : 'up'
		lastScrollY = currentScrollY

		if (window.scrollY > mainHeader.offsetHeight) {
			stick()
		} else if (window.scrollY <= 0) {
			unstick()
		}

		if (stuck) {
			if (scrollDirection === 'down' && !headerCollapsed) {
				headerCollapsed = true
				mainHeader.style.transform = 'translateY(-100%)'
				mainHeader.style.boxShadow = '0'
				document.documentElement.style.setProperty('--header-height', '0')
			} else if (scrollDirection === 'up' && headerCollapsed) {
				headerCollapsed = false
				mainHeader.style.transform = 'translateY(0)'
				mainHeader.style.boxShadow = '0 1rem 0 #e6ebef'
				document.documentElement.style.setProperty('--header-height', `${mainHeader.offsetHeight}px`)
			}
		}
	})

	// Fix weird transition gap when resizing window
	let timeout = null
	window.addEventListener('resize', () => {
		mainHeader.style.transition = 'none'
		subnavs.forEach((subnav) => {
			subnav.style.transition = 'none'
		})
		clearTimeout(timeout)
		timeout = setTimeout(() => {
			mainHeader.style.transition = ''
			subnavs.forEach((subnav) => {
				subnav.style.transition = ''
			})
		}, 200)

		// We call collapseMenu and collapseAllSubmenus once before and once after window.mobile is set to true in order to make sure both versions of the menu are properly reset when transitioning between desktop and mobile.
		if (window.innerWidth >= 960 && navMobile) {
			navMobile = true
			collapseAllSubmenus()
			collapseMenu()
			navMobile = false
			collapseMenu()
			collapseAllSubmenus()
		} else if (window.innerWidth <= 960 && !navMobile) {
			navMobile = false
			collapseAllSubmenus()
			collapseMenu()
			navMobile = true
			collapseMenu()
			collapseAllSubmenus()
		}
		navMobile = window.navMobile
	})

	function stick() {
		if (!stuck) {
			stuck = true
			mainHeader.style.position = 'fixed'
			// Don't transition when first sticking.
			mainHeader.style.transition = 'none'
			document.body.style.paddingTop = `${mainHeader.offsetHeight}px`
			setTimeout(() => {
				mainHeader.style.transition = ''
			})
		}
	}

	function unstick() {
		if (stuck) {
			stuck = false
			mainHeader.style.position = ''
			document.body.style.paddingTop = ''
		}
	}

	function collapseSecondLevelSubnavs(subnav) {
		if (!subnav) return

		subnav.querySelectorAll('[data-second-level-subnav]').forEach((button) => {
			button.expanded = false
			if (button.nextElementSibling) {
				button.nextElementSibling.style.height = ''
			}
		})
	}

	function collapseOthers(link) {
		mainLinks.forEach((otherLink) => {
			if (otherLink !== link && otherLink.expanded) {
				collapseSubmenu(otherLink)
			}
		})
	}

	function expandSubmenu(link) {
		collapseOthers(link)

		const subnav = link.parentNode.querySelector('.subnav')

		if (!subnav) return

		const arrow = link.querySelector('svg')

		arrow.classList.add('rotate-180', 'opacity-100')
		link.classList.add('text-blue300')

		menuOverlay.classList.add('opacity-100')
		menuOverlay.classList.remove('pointer-events-none')

		expanded = true

		subnav.parentElement.style.visibility = ''
		subnav.style.opacity = '1'
		subnav.style.setProperty('--tw-translate-y', '0')
		subnav.classList.add('pointer-events-auto')

		if (window.navMobile) {
			collapseSecondLevelSubnavs(subnav)

			arrow.classList.add('fill-white')
			link.classList.add('bg-blue300', 'text-white')

			let subnavHeight = 0
			subnav.querySelectorAll('[data-subnav-links] > div').forEach((section) => {
				subnavHeight += section.offsetHeight
			})
			subnav.style.height = `${subnavHeight}px`
		}
	}

	function collapseAllSubmenus() {
		mainLinks.forEach((link) => {
			collapseSubmenu(link)
		})
	}

	function collapseSubmenu(linkToCollapse) {
		if (!linkToCollapse) {
			mainLinks.forEach((link) => {
				if (link.expanded) {
					linkToCollapse = link
				}
			})
		}
		
		const subnav = linkToCollapse?.parentNode?.querySelector('.subnav')

		if (!subnav) return

		const arrow = linkToCollapse.querySelector('svg')
		
		arrow.classList.remove('rotate-180', 'opacity-100')
		linkToCollapse.classList.remove('text-blue300')
		
		linkToCollapse.expanded = false
		expanded = false
		
		menuOverlay.classList.remove('opacity-100')
		menuOverlay.classList.add('pointer-events-none')
		
		subnav.style.opacity = '0'

		subnav.style.setProperty('--tw-translate-y', '')
		subnav.classList.remove('pointer-events-auto')

		if (window.navMobile) {
			collapseSecondLevelSubnavs(subnav)

			arrow.classList.remove('fill-white')
			linkToCollapse.classList.remove('bg-blue300', 'text-white')
			subnav.style.height = `0`
		} else {
			subnav.style.height = ''
		}
	}

	mainLinks.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault()
			e.stopPropagation()

			link.expanded = !link.expanded

			if (link.expanded) {
				expandSubmenu(link)
			} else {
				collapseSubmenu(link)
			}
		})
	})

	subnavsLinks.forEach((button) => {
		button.expanded = false

		button.addEventListener('click', (e) => {
			e.preventDefault()
			e.stopPropagation()

			const clicked = e.currentTarget
			const linksWrapper = clicked.nextElementSibling
			if (!linksWrapper) return

			clicked.expanded = !clicked.expanded
			if (clicked.expanded) {
				let linksWrapperHeight = 0
				linksWrapper.querySelectorAll('a').forEach((link) => {
					linksWrapperHeight += link.offsetHeight
				})
				linksWrapper.style.height = `${linksWrapperHeight}px`

				subnavsLinks.forEach((otherButton) => {
					if (otherButton !== clicked && otherButton.expanded) {
						const otherLinksWrapper = otherButton.nextElementSibling
						const otherButtonHeight = otherLinksWrapper?.offsetHeight || 0
						otherButton.expanded = false
						if (otherLinksWrapper) {
							otherLinksWrapper.style.height = ''
						}
						const parentSubnav = otherButton.closest('.subnav')

						setTimeout(() => {
							if (parentSubnav && parentSubnav.contains(clicked)) {
								const parentSubnavHeight = parentSubnav.offsetHeight
								parentSubnav.style.height = `${parentSubnavHeight - otherButtonHeight + linksWrapperHeight}px`
							}
						}, 1)
					}
				})

				const parentSubnav = linksWrapper.closest('.subnav')
				if (parentSubnav) {
					const parentSubnavHeight = parentSubnav.offsetHeight
					parentSubnav.style.height = `${parentSubnavHeight + linksWrapperHeight}px`
				}
			} else {
				const linksWrapperHeight = linksWrapper.offsetHeight
				const parentSubnav = linksWrapper.closest('.subnav')
				if (parentSubnav) {
					const parentSubnavHeight = parentSubnav.offsetHeight
					parentSubnav.style.height = `${parentSubnavHeight - linksWrapperHeight}px`
				}

				linksWrapper.style.height = ''
			}
		})
	})

	const search = document.querySelector('header .search')
	const inputWrapper = search.querySelector('.input_wrapper')
	const input = inputWrapper.querySelector('input')
	const closeIcon = searchToggle.querySelector('svg:last-child')
	const openIcon = searchToggle.querySelector('svg:first-child')
	const submitButton = search.querySelector('button[type="submit"]')

	searchInput.addEventListener('keydown', (e) => {
		if (e.code == 'Escape') {
			if (inputWrapper.open) {
				searchToggle.click()
				input.value = ''
			}
		}
	})

	searchToggle.addEventListener('click', (e) => {
		e.preventDefault()

		// Only prevent default for actual mouse clicks
		if (e.pointerType === 'mouse') {
			e.preventDefault()
			e.stopPropagation()
		}

		if (e.pointerType === 'touch') {
			e.preventDefault()
			e.stopPropagation()
			window.location.href = '/search'
			return
		}

		inputWrapper.open = !inputWrapper.open
		if (inputWrapper.open) {
			inputWrapper.style.width = '300px'
			inputWrapper.style.borderColor = '#c9cdd0'
			input.style.opacity = 1
			input.focus()
			input.style.pointerEvents = 'auto'
			inputWrapper.querySelector('input').focus()
			closeIcon.classList.toggle('hidden')
			openIcon.classList.toggle('hidden')
			submitButton.classList.add('opacity-100', 'cursor-pointer')
			submitButton.classList.remove('pointer-events-none', 'opacity-0')
			submitButton.removeAttribute('tabindex')
			input.removeAttribute('tabindex')
		} else {
			input.style.opacity = 0
			inputWrapper.style.width = ''
			inputWrapper.style.borderColor = ''
			input.style.pointerEvents = ''
			closeIcon.classList.toggle('hidden')
			openIcon.classList.toggle('hidden')
			submitButton.classList.add('pointer-events-none', 'opacity-0')
			submitButton.classList.remove('opacity-100', 'cursor-pointer')
			submitButton.setAttribute('tabindex', '-1')
			input.setAttribute('tabindex', '-1')
		}
	})

	function collapseMenu() {
		menuExpanded = false
		collapseAllSubmenus()
		nav.style.setProperty('top', '')
		mobileMenuToggle.querySelector('#hamburger').style.opacity = ''
		mobileMenuToggle.querySelector('#close_menu').style.opacity = ''
		document.documentElement.style.overflow = ''
		document.body.style.overflow = ''
	}

	function expandMenu() {
		menuExpanded = true
		nav.style.setProperty('top', '0')
		mobileMenuToggle.querySelector('#hamburger').style.opacity = 0
		mobileMenuToggle.querySelector('#close_menu').style.opacity = 1
		document.documentElement.style.overflow = 'hidden'
		document.body.style.overflow = 'hidden'
	}

	mobileMenuToggle.addEventListener('click', () => {
		menuExpanded = !menuExpanded

		if (menuExpanded) {
			expandMenu()
		} else {
			collapseMenu()
		}
	})

	menuOverlay.addEventListener('click', () => {
		collapseSubmenu()
	})

	//delay scroll to hash for anchor links to give time for hydration
	if (window.location.hash) {
		var hash = window.location.hash;
		history.replaceState(null, null, ' '); 
		
		window.addEventListener('load', function() {
			history.replaceState(null, null, hash);

			const targetElement = document.querySelector(hash);
			if (targetElement) {
				scrollToElement(targetElement)
			}
		});
	}
}

header()